import produce from 'immer'
import Actions from '../actions'

const initialState = {
  pharmacies: null,
  isLoadingSearchPharmacy: false,
}

export default produce((draft, action) => {
  const { payload } = action

  switch (action.type) {
    case Actions.SEARCH_PHARMACY_RECEIVED: {
      draft.pharmacies = payload.payload.Items
      draft.isLoadingSearchPharmacy = false
      break
    }
    case Actions.SEARCH_PHARMACY_REQUESTED: {
      draft.isLoadingSearchPharmacy = true
      break
    }
    case Actions.UPDATE_MY_PHARMACY_REQUESTED:
    case Actions.SEARCH_PHARMACY_CLEARED: {
      draft.pharmacies = null
      draft.isLoadingSearchPharmacy = false
      break
    }
    case Actions.SIGNOUT_RECEIVED:
      return initialState
    default: {
      // Nothing to do
      break
    }
  }
}, initialState)
